"use strict";

var _mapFactory = require("./map-factory");

var _mapFactory2 = _interopRequireDefault(_mapFactory);

var _objectMapper = require("./object-mapper/object-mapper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _mapFactory2.default;
module.exports.getValue = _objectMapper.getValue;
module.exports.setValue = _objectMapper.setValue;


//////////////////
// WEBPACK FOOTER
// ./node_modules/map-factory/dist/lib/index.js
// module id = zi+m
// module chunks = 9